import angular from 'angular';
import CarsNgTracking from 'cars-ng-tracking';

import component from './vdpConsumerReviewSection.component';
import service from './vdpConsumerReviewSection.service';

export default angular.module('vdp.vdpConsumerReviewSection', [
    CarsNgTracking
])

.component('carsVdpConsumerReviewSection', component)
.factory('vdpConsumerReviewService', service)
.name;